import { i as isArray } from './isArray-ecf6b854.js';
import __vue_component__$1 from './MdButton.js';
import __vue_component__$2 from './MdIcon.js';
import __vue_component__$3 from './TmdIcon.js';
import { n as normalizeComponent } from './normalize-component-cf2db48b.js';
import { c as createInjector } from './browser-ac904bdc.js';

function refPromise() {
  return new Promise(resolve => {
    requestAnimationFrame(resolve);
  });
}
function asyncReference(env, selector, retries = 10) {
  if (env.$refs[`${selector}`] !== undefined) {
    return Promise.resolve(true);
  }
  retries -= 1;
  if (retries <= 0) {
    return Promise.reject(Error(`${selector} not found`));
  }
  return refPromise().then(() => {
    return new Promise(resolve => {
      setTimeout(() => {
        resolve(asyncReference(env, selector, retries));
      }, 200);
    });
  });
}

const MdInputContainer = {
  name: "md-input-container",
  components: {
    MdButton: __vue_component__$1,
    MdIcon: __vue_component__$2,
    TmdIcon: __vue_component__$3
  },
  props: {
    mdMultipleLines: {
      type: Boolean,
      default: false
    },
    mdSingleLine: {
      type: Boolean,
      default: false
    },
    mdInline: {
      type: Boolean,
      default: false
    },
    mdHasPassword: {
      type: Boolean,
      default: false
    },
    mdAlwaysClearable: {
      type: Boolean,
      default: false
    },
    mdClearable: {
      type: Boolean,
      default: false
    },
    mdSimple: {
      type: Boolean,
      default: false
    },
    mdClear: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      value: "",
      input: false,
      inputInstance: null,
      showPassword: false,
      enableCounter: false,
      focusable: false,
      hasSelect: false,
      hasPlaceholder: false,
      hasFile: false,
      isDisabled: false,
      isRequired: false,
      isFocused: false,
      counterLength: 0,
      inputLength: 0,
      mdiEyeIcon: null,
      mdiEyeOffIcon: null,
      inputPrefix: null
    };
  },
  mounted() {
    this.evaluateDropdowChild();
  },
  watch: {
    inputInstance: {
      handler(newInstanceVal) {
        if (newInstanceVal) {
          this.evaluateChild();
        }
      }
    }
  },
  computed: {
    hasValue() {
      if (isArray(this.value)) {
        return this.value.length > 0;
      }
      return Boolean(this.value);
    },
    prefixWidth() {
      return this.$slots.prefix && this.inputPrefix ? this.inputPrefix.offsetWidth : 0;
    },
    cssVariables() {
      return {
        "--md-input-container-prefix-width": `${this.prefixWidth}px`
      };
    },
    classes() {
      return {
        "md-single-line": this.mdSingleLine,
        "md-input-inline": this.mdInline,
        "md-has-password": this.mdHasPassword,
        "md-clearable": this.mdClearable,
        "md-has-select": this.hasSelect,
        "md-has-counter": this.enableCounter,
        "md-has-file": this.hasFile,
        "md-has-value": this.hasValue,
        "md-has-label": !!this.$slots.label,
        "md-input-placeholder": this.hasPlaceholder,
        "md-input-disabled": this.isDisabled,
        "md-input-required": this.isRequired,
        "md-input-focused": this.isFocused && !this.isDisabled,
        "md-input-container--simple": this.mdSimple,
        "md-input-container--clear": this.mdClear
      };
    },
    showClearButton() {
      return this.mdClearable && (this.hasValue || this.mdAlwaysClearable);
    },
    tabIndex() {
      return this.focusable ? "0" : "-1";
    },
    hasSuffixSlot() {
      return !!this.$slots["suffix"] || !!this.$scopedSlots["suffix"];
    }
  },
  async created() {
    const {
      mdiEye,
      mdiEyeOff
    } = await import('./mdiImports-f5901505.js');
    this.mdiEyeIcon = mdiEye;
    this.mdiEyeOffIcon = mdiEyeOff;
  },
  mounted() {
    if (this.$slots.prefix) {
      asyncReference(this, "inputPrefix").then(() => {
        this.inputPrefix = this.$refs.inputPrefix;
      });
    }
  },
  methods: {
    callExternalOpen() {
      if (this.focusable) {
        this.$emit("external-open");
      }
    },
    isInput() {
      return this.input && this.input.tagName && this.input.tagName.toLowerCase() === "input";
    },
    togglePasswordType() {
      if (this.isInput()) {
        if (this.input.type === "password") {
          this.input.type = "text";
          this.showPassword = true;
        } else {
          this.input.type = "password";
          this.showPassword = false;
        }
        this.input.focus();
      }
    },
    clearInput(defaultValue = null) {
      this.inputInstance.$el.value = defaultValue !== null && defaultValue !== void 0 ? defaultValue : "";
      this.inputInstance.$emit("input", defaultValue !== null && defaultValue !== void 0 ? defaultValue : "");
      this.setValue(defaultValue !== null && defaultValue !== void 0 ? defaultValue : "");
      this.$emit("md-clear");
    },
    setValue(value) {
      this.value = value;
    },
    evaluateDropdowChild() {
      var _this$$children;
      const isDropdown = (_this$$children = this.$children) === null || _this$$children === void 0 ? void 0 : _this$$children.some(child => {
        var _child$$options;
        return (child === null || child === void 0 || (_child$$options = child.$options) === null || _child$$options === void 0 ? void 0 : _child$$options._componentTag) === "md-select";
      });
      this.focusable = !!isDropdown;
    },
    evaluateChild() {
      this.$nextTick(() => {
        this.input = this.$el.querySelectorAll("input, textarea, select, .md-file")[0];
        this.$nextTick(() => {
          if (!this.input) {
            this.$destroy();
            throw new Error("Missing input/select/textarea inside md-input-container");
          }
        });
      });
    }
  }
};

const __vue_script__ = MdInputContainer;
var __vue_render__ = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', {
    staticClass: "md-input-container",
    class: [_vm.classes],
    style: _vm.cssVariables,
    attrs: {
      "tabindex": _vm.tabIndex
    },
    on: {
      "keyup": [function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "space", 32, $event.key, [" ", "Spacebar"])) {
          return null;
        }
        return _vm.callExternalOpen.apply(null, arguments);
      }, function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) {
          return null;
        }
        return _vm.callExternalOpen.apply(null, arguments);
      }]
    }
  }, [_vm.$slots.prefix ? _c('span', {
    ref: "inputPrefix",
    staticClass: "md-input-container__prefix"
  }, [_vm._t("prefix")], 2) : _vm._e(), _vm._v(" "), _vm._t("default"), _vm._v(" "), _vm.mdInline && _vm.$slots.label ? _c('label', [_vm._t("label")], 2) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "outlined-notched"
  }, [_c('div', {
    staticClass: "outlined-notched__leading"
  }), _vm._v(" "), _c('div', {
    class: ['outlined-notched__notch', {
      'md-has-suffix-slot': _vm.hasSuffixSlot
    }]
  }, [!_vm.mdInline && _vm.$slots.label ? _c('label', {
    class: [{
      'md-multiple-lines': _vm.mdMultipleLines && !_vm.hasValue
    }]
  }, [_vm._t("label")], 2) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "outlined-notched__trailing"
  })]), _vm._v(" "), _vm.enableCounter ? _c('span', {
    staticClass: "md-count"
  }, [_vm._v(_vm._s(_vm.inputLength) + " / " + _vm._s(_vm.counterLength))]) : _vm._e(), _vm._v(" "), _vm.mdHasPassword ? _c('md-button', {
    staticClass: "md-icon-button md-toggle-password",
    attrs: {
      "tabindex": "-1"
    },
    on: {
      "click": function ($event) {
        $event.preventDefault();
        return _vm.togglePasswordType.apply(null, arguments);
      }
    }
  }, [_c('md-icon', {
    attrs: {
      "icon-svg": _vm.showPassword ? _vm.mdiEyeOffIcon : _vm.mdiEyeIcon
    }
  })], 1) : _vm._e(), _vm._v(" "), _vm.showClearButton ? _c('md-button', {
    staticClass: "md-icon-button md-clear-input",
    attrs: {
      "tabindex": "-1"
    },
    on: {
      "click": function ($event) {
        return _vm.clearInput();
      }
    }
  }, [_c('tmd-icon', [_vm._v(" close ")])], 1) : _vm._e(), _vm._v(" "), _vm.$slots.suffix ? _c('span', {
    staticClass: "md-input-container__suffix"
  }, [_vm._t("suffix")], 2) : _vm._e()], 2);
};
var __vue_staticRenderFns__ = [];
const __vue_inject_styles__ = function (inject) {
  if (!inject) return;
  inject("data-v-99fde270_0", {
    source: ".md-input-container{width:100%;min-height:46px;margin:16px 0 30px;display:flex;position:relative}.md-input-container.md-single-line{min-height:52px;margin:24px 0 8px}.md-input-container__prefix,.md-input-container__suffix{color:rgba(255,255,255,.65);font-size:16px;align-self:center}.md-input-container__prefix{padding-left:16px;margin-right:8px}.md-input-container__suffix{padding-right:12px;margin-left:8px}.md-input-container:not(.md-input-disabled):not(.md-input-focused){border-color:rgba(255,255,255,.65)}.md-input-container:not(.md-input-disabled):not(.md-input-focused) .outlined-notched__leading,.md-input-container:not(.md-input-disabled):not(.md-input-focused) .outlined-notched__notch,.md-input-container:not(.md-input-disabled):not(.md-input-focused) .outlined-notched__trailing{border-color:rgba(255,255,255,.65)}.md-input-container:not(.md-input-disabled):not(.md-input-focused) .outlined-notched__notch{padding-left:var(--md-input-container-prefix-width,0)}.md-input-container:not(.md-input-disabled):not(.md-input-focused) .outlined-notched__notch .md-multiple-lines{top:25%}.md-input-container:not(.md-input-disabled):not(.md-input-focused):hover:not(.md-input-invalid){border-color:rgba(255,255,255,.9)}.md-input-container:not(.md-input-disabled):not(.md-input-focused):hover:not(.md-input-invalid) label,.md-input-container:not(.md-input-disabled):not(.md-input-focused):hover:not(.md-input-invalid)>.md-icon{color:rgba(255,255,255,.9)}.md-input-container:not(.md-input-disabled).md-input-invalid{border-color:#cf6679}.md-input-container:not(.md-input-disabled).md-input-invalid .outlined-notched__leading,.md-input-container:not(.md-input-disabled).md-input-invalid .outlined-notched__notch,.md-input-container:not(.md-input-disabled).md-input-invalid .outlined-notched__trailing{border-color:#cf6679}.md-input-container:not(.md-input-disabled).md-input-invalid .md-count,.md-input-container:not(.md-input-disabled).md-input-invalid .md-error,.md-input-container:not(.md-input-disabled).md-input-invalid .md-icon:not(.md-icon-delete),.md-input-container:not(.md-input-disabled).md-input-invalid input,.md-input-container:not(.md-input-disabled).md-input-invalid label,.md-input-container:not(.md-input-disabled).md-input-invalid textarea{color:#cf6679}.md-input-container:not(.md-input-disabled).md-input-invalid .outlined-notched__notch{padding-left:var(--md-input-container-prefix-width,0)}.md-input-container.md-input-disabled{border-color:rgba(255,255,255,.38);color:rgba(255,255,255,.38)}.md-input-container.md-input-disabled .outlined-notched__leading,.md-input-container.md-input-disabled .outlined-notched__notch,.md-input-container.md-input-disabled .outlined-notched__trailing{border-color:rgba(255,255,255,.38)}.md-input-container.md-input-disabled .md-count,.md-input-container.md-input-disabled .md-error,.md-input-container.md-input-disabled .md-icon:not(.md-icon-delete),.md-input-container.md-input-disabled input,.md-input-container.md-input-disabled label,.md-input-container.md-input-disabled textarea{color:rgba(255,255,255,.38)}.md-input-container label{color:rgba(255,255,255,.65)}.md-input-container input,.md-input-container textarea{color:rgba(255,255,255,.9)}.md-input-container :-moz-placeholder,.md-input-container :-ms-input-placeholder,.md-input-container ::-moz-placeholder,.md-input-container ::-webkit-input-placeholder{color:rgba(255,255,255,.65)}.md-input-container .md-icon:not(.md-icon-delete){color:rgba(255,255,255,.65)}.md-input-container.md-has-value input,.md-input-container.md-has-value textarea{color:rgba(255,255,255,.9)}.md-input-container.md-has-value.md-input-disabled input,.md-input-container.md-has-value.md-input-disabled textarea{color:rgba(255,255,255,.38)}.md-input-container.md-has-password.md-input-focused .md-toggle-password{color:rgba(255,255,255,.65)}.md-input-container.md-has-password .md-toggle-password{color:rgba(255,255,255,.38)}.md-input-container.md-has-password .md-toggle-password .md-ink-ripple{color:rgba(255,255,255,.9)}.md-input-container.md-clearable.md-input-focused .md-clear-input{color:rgba(255,255,255,.65)}.md-input-container.md-clearable .md-clear-input{color:rgba(255,255,255,.38)}.md-input-container.md-clearable .md-clear-input .md-ink-ripple{color:rgba(255,255,255,.9)}.md-input-container.md-has-select:hover .md-select:not(.md-disabled):after{color:var(--theme-color,#cddc39)}.md-input-container .md-error:first-letter{text-transform:uppercase}.md-input-container.tdl-typeahead.has-only-item.md-input-disabled:after{background-color:rgba(255,255,255,.12)!important}.md-input-container .outlined-notched{display:flex;position:absolute;right:0;left:0;box-sizing:border-box;width:100%;max-width:100%;height:100%;text-align:left;pointer-events:none}.md-input-container .outlined-notched__leading,.md-input-container .outlined-notched__notch,.md-input-container .outlined-notched__trailing{border:1px solid;pointer-events:none;text-align:left;transition:all .4s cubic-bezier(.25,.8,.25,1)}.md-input-container .outlined-notched__leading{border-radius:4px 0 0 4px;border-right:none;width:12px}.md-input-container .outlined-notched__notch{border-radius:.1px;flex-grow:1;border-right:none;border-left:none;max-width:calc(100% - 24px)}@media (max-width:400px){.md-input-container .outlined-notched__notch.md-has-suffix-slot{max-width:calc(100% - 85px)}}.md-input-container .outlined-notched__trailing{border-radius:0 4px 4px 0;border-left:none;flex-grow:1}.md-input-container.md-input-container--clear,.md-input-container.md-input-container--simple{border-bottom:1px solid}.md-input-container.md-input-container--clear.md-has-value label,.md-input-container.md-input-container--clear.md-input-focused label,.md-input-container.md-input-container--simple.md-has-value label,.md-input-container.md-input-container--simple.md-input-focused label{top:-8px}.md-input-container.md-input-container--clear .outlined-notched__leading,.md-input-container.md-input-container--clear .outlined-notched__notch,.md-input-container.md-input-container--clear .outlined-notched__trailing,.md-input-container.md-input-container--simple .outlined-notched__leading,.md-input-container.md-input-container--simple .outlined-notched__notch,.md-input-container.md-input-container--simple .outlined-notched__trailing{border:none!important}.md-input-container.md-input-container--clear{border-color:transparent!important;margin:0}.md-input-container.md-input-container--simple input{padding-bottom:0;padding-left:0}.md-input-container.md-input-container--simple label{left:-12px}.md-input-container.md-input-focused{border-color:var(--theme-color,#cddc39)!important}.md-input-container.md-input-focused:not(.md-input-invalid).md-input-required label:after{color:var(--theme-color,#cddc39)}.md-input-container.md-input-focused:not(.md-input-invalid) .outlined-notched__leading,.md-input-container.md-input-focused:not(.md-input-invalid) .outlined-notched__notch,.md-input-container.md-input-focused:not(.md-input-invalid) .outlined-notched__trailing{border-color:var(--theme-color,#cddc39)!important;border:1px solid}.md-input-container.md-input-focused:not(.md-input-invalid) .outlined-notched__leading{border-right:none}.md-input-container.md-input-focused:not(.md-input-invalid) .outlined-notched__notch{border-right:none;border-left:none}.md-input-container.md-input-focused:not(.md-input-invalid) .outlined-notched__trailing{border-left:none}.md-input-container.md-input-focused.md-input-inline label{color:rgba(255,255,255,.65)}.md-input-container.md-input-focused input,.md-input-container.md-input-focused textarea{color:rgba(255,255,255,.9);text-shadow:0 0 0 rgba(255,255,255,.9);-webkit-text-fill-color:transparent}.md-input-container.md-input-focused .md-icon:not(.md-icon-delete),.md-input-container.md-input-focused label{color:var(--theme-color,#cddc39)}.md-input-container.md-input-focused .md-chips{color:rgba(255,255,255,.9)}.md-input-container.md-has-label:not(.md-input-focused) ::-webkit-input-placeholder{color:transparent}.md-input-container.md-has-label:not(.md-input-focused) :-moz-placeholder{color:transparent}.md-input-container.md-has-label:not(.md-input-focused) ::-moz-placeholder{color:transparent}.md-input-container.md-has-label:not(.md-input-focused) :-ms-input-placeholder{color:transparent}.md-input-container.md-has-counter .md-error{width:calc(100% - 60px)}.md-input-container label:not(.md-radio-label){display:inline-block;position:relative;max-width:100%;font-size:16px;left:4px;right:initial;top:50%;transform:translateY(-50%);overflow:hidden;white-space:nowrap;text-overflow:ellipsis;pointer-events:none;transition:all .4s cubic-bezier(.25,.8,.25,1);transition-duration:150ms}.md-input-container input{width:100%}.md-input-container .md-menu,.md-input-container input,.md-input-container textarea{display:flex;padding:6px 16px 8px;border:none!important;background-color:transparent;z-index:1;flex:1;transition:all .4s cubic-bezier(.25,.8,.25,1);transition-property:font-size;font-family:inherit;font-size:16px;line-height:32px;resize:none}.md-input-container .md-menu:focus,.md-input-container input:focus,.md-input-container textarea:focus{outline:0}.md-input-container ::-webkit-input-placeholder{font-size:16px;text-shadow:none;-webkit-text-fill-color:initial}.md-input-container :-moz-placeholder{font-size:16px;text-shadow:none;-webkit-text-fill-color:initial}.md-input-container ::-moz-placeholder{font-size:16px;text-shadow:none;-webkit-text-fill-color:initial}.md-input-container :-ms-input-placeholder{font-size:16px;text-shadow:none;-webkit-text-fill-color:initial}.md-input-container>.md-icon{margin-right:16px;margin-left:16px}.md-input-container>.md-icon+input,.md-input-container>.md-icon+textarea{padding-left:0}.md-input-container:not(.md-input-focused):not(.md-has-value)>.md-icon~.outlined-notched label{position:absolute;left:60px;max-width:calc(100% - 63px)}.md-input-container .md-count,.md-input-container .md-error{height:20px;position:absolute;left:16px;bottom:-20px;font-size:12px}.md-input-container .md-error{display:block!important;width:calc(100% - 22px);opacity:0;transform:translate3d(0,-8px,0);transition:all .3s cubic-bezier(.55,0,.55,.2);white-space:normal;overflow:unset;text-overflow:ellipsis;line-height:normal;padding-top:4px;left:0;margin-left:16px}.md-input-container .md-count{left:initial;right:0;opacity:.54}.md-input-container .md-autocomplete,.md-input-container .md-autocomplete .md-menu,.md-input-container .md-autocomplete .md-menu .md-input{width:100%}.md-input-container.md-has-value label,.md-input-container.md-input-focused label{pointer-events:auto;top:-1px;font-size:12px;line-height:16px}.md-input-container.md-has-value input,.md-input-container.md-has-value textarea,.md-input-container.md-input-focused input,.md-input-container.md-input-focused textarea{font-size:16px;-webkit-text-fill-color:currentColor}.md-input-container.md-has-value.md-has-label .outlined-notched__notch,.md-input-container.md-input-focused.md-has-label .outlined-notched__notch{flex-grow:0;max-width:83%;border-right:none;border-left:none;border-top:none;padding:1px 8px 0 0}.md-input-container.md-input-inline label{position:absolute;left:16px;pointer-events:none}.md-input-container.md-input-inline.md-has-value label,.md-input-container.md-input-inline.md-input-focused label{font-size:16px;top:50%}.md-input-container.md-input-inline.md-has-value .outlined-notched__notch,.md-input-container.md-input-inline.md-input-focused .outlined-notched__notch{border-right:none;border-left:none;padding:0}.md-input-container.md-input-inline.md-has-value label{opacity:0}.md-input-container.md-clearable input,.md-input-container.md-clearable textarea,.md-input-container.md-has-password input,.md-input-container.md-has-password textarea{padding-right:48px}.md-input-container.md-clearable .md-button,.md-input-container.md-has-password .md-button{z-index:2;position:absolute!important;left:initial;right:0;top:50%!important;transform:translateY(-50%)}.md-input-container.md-input-invalid .md-error{opacity:1;transform:translate3d(0,0,0)}.md-input-container.md-input-required label:after{top:2px;right:0;transform:translateX(calc(100% + 2px));content:\"*\";font-size:12px;line-height:1em;vertical-align:baseline}",
    map: undefined,
    media: undefined
  });
};
const __vue_scope_id__ = undefined;
const __vue_module_identifier__ = undefined;
const __vue_is_functional_template__ = false;
const __vue_component__ = normalizeComponent({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__, __vue_module_identifier__, false, createInjector, undefined, undefined);

export { __vue_component__ as _, asyncReference as a };
